import React, { useState, useEffect } from 'react';

// project-imports
import { useEnquiryContext } from '../../context/enquiry_context';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import { useSelector } from 'react-redux';
import { isBlockedDomain } from '../../utils';

// Reading environment variables
const INVALID_NAME_ERROR_MESSAGE = process.env.REACT_APP_INVALID_FULLNAME_ERROR_MESSAGE;
const INVALID_EMAIL_ERROR_MESSAGE = process.env.REACT_APP_INVALID_EMAIL_ERROR_MESSAGE;
const NAME_ERROR_MESSAGE = process.env.REACT_APP_NAME_ERROR_MESSAGE;
const EMAIL_ERROR_MESSAGE = process.env.REACT_APP_EMAIL_ERROR_MESSAGE;
const DESCRIPTION_ERROR_MESSAGE = process.env.REACT_APP_TOPIC_DESCRIPTION_ERROR_MESSAGE;

// Success Message Component
const Result = () => (
    <p className="success-message">Thanks for your suggestion. We'll look into this and get back to you soon.</p>
);

function SuggestTopic({ formStyle = "rnt-contact-form rwt-dynamic-form row", closeForm, type }) {

    // Reading Context methods and variables
    const { submitEnquiry: submitTopicSuggestion, isLoading } = useEnquiryContext();
    const { loginData } = useSelector((item) => item.user);

    // Constant variable
    const patterns = {
        name: /^[A-Z][a-zA-Z]*((\s[A-Z][a-zA-Z]*)*){3,50}$/,
        email: /^[a-zA-Z0-9!#$%&*+=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&*=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,}(?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
        message: /^[\w\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{3,500}$/
    };
    const currentMember = loginData && loginData.data && loginData.data?.userId ? loginData.data : {};

    // Local stat initialization
    const [result, setResult] = useState(false);
    const [suggestTopic, setSuggestTopic] = useState({
        name: currentMember && currentMember?.userFullName ? currentMember?.userFullName : '',
        email: currentMember && currentMember?.userId ? currentMember?.userId : '',
        message: ''
    });
    const [inputValidationErrors, setInputValidationErrors] = useState({
        name: "",
        email: "",
        message: ""
    });

    // Constant functions
    // Validation handler
    const validateField = (data, name) => {
        try {
            // const isValid = patterns[name].test(data[name]?.value);
            let validationObj = {};
            if (name === "name" || name === "all") {
                if (data && (!data.name || (data.name && !data.name.length))) {
                    validationObj.name = "Full Name is required!"
                } else if (data && data.name && (data?.name?.length < 3 || data?.name?.length > 50)) {
                    validationObj.name = "Full Name must be 3-50 characters long!";
                } else if (data && data.name && !(patterns["name"].test(data?.name))) {
                    validationObj.name = NAME_ERROR_MESSAGE;
                } else if (data && data.name && isBlockedDomain(data?.name)) {
                    validationObj.name = INVALID_NAME_ERROR_MESSAGE;
                } else {
                    validationObj.name = "";
                }
            }
            if (name === "email" || name === "all") {
                if (data && (!data.email || (data.email && !data.email.length))) {
                    validationObj.email = "Email is required!"
                } else if (data && data.email && !(patterns["email"].test(data?.email))) {
                    validationObj.email = EMAIL_ERROR_MESSAGE;
                } else if (data && data.email && isBlockedDomain(data?.email)) {
                    validationObj.email = INVALID_EMAIL_ERROR_MESSAGE;
                } else {
                    validationObj.email = "";
                }
            }
            if (name === "message" || name === "all") {
                if (data && (!data.message || (data.message && !data.message.length))) {
                    validationObj.message = "Topic Description is required!"
                } else if (data && data.message && !(patterns["message"].test(data?.message))) {
                    validationObj.message = DESCRIPTION_ERROR_MESSAGE;
                } else {
                    validationObj.message = "";
                }
            }
            setInputValidationErrors((prev) => ({ ...prev, ...validationObj }));
            return validationObj;
        } catch (error) {
            console.log("83 : SuggestTopic : Error while checking validation :", error && JSON.stringify(error));
            throw error;
        }
    };

    const handleChange = (e) => {
        try {
            const { name, value } = e.target;

            const data = {
                [name]: value
            };

            setInputValidationErrors((prev) => ({ ...prev, ...validateField(data, name) }));
            setSuggestTopic((prev) => ({ ...prev, ...data }));
        } catch (error) {
            console.log("99 : SuggestTopic : Error while changing value :", error && JSON.stringify(error));
            throw error;
        }
    };

    const handleSubmitSuggestion = async () => {
        try {

            let isFormValid = true;
            const valid = validateField(suggestTopic, "all");

            if (valid.name || valid.email || valid.message) {
                isFormValid = false;
            }

            if (isFormValid) {

                const isAnyFieldEmpty = Object.values(suggestTopic).some((val) => !val.trim());
                const hasValidationErrors = Object.values(inputValidationErrors).some((error) => error);

                if (isAnyFieldEmpty || hasValidationErrors) {
                    return;
                }

                suggestTopic["phone"] = "8000000000";
                suggestTopic["subject"] = type === "Session" ? "One on one session by user" : "Topic suggestion by user";
                await submitTopicSuggestion(suggestTopic);
                triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.SUGGEST_TOPIC_FORM_SUBMIT_BUTTON);

                // e.target.reset();
                setSuggestTopic({
                    name: currentMember && currentMember?.userFullName ? currentMember?.userFullName : '',
                    email: currentMember && currentMember?.userId ? currentMember?.userId : '',
                    message: ''
                });
                setResult(true);
            }
        } catch (error) {
            console.log("137 : SuggestTopic : Error while submitting suggestion :", error && JSON.stringify(error));
            throw error;
        }
    };

    // Reset result message after 2s
    useEffect(() => {
        if (result) {
            const timer = setTimeout(() => setResult(false), 2000);
            return () => { clearTimeout(timer); closeForm && closeForm(); };
        }
    }, [result]);

    return (
        <div className={formStyle}>
            <div className="col-lg-12">
                <div className="form-group">
                    <label htmlFor='name'>Enter Full Name*</label>
                    <input
                        disabled={isLoading || (currentMember && currentMember?.userId)}
                        type="text"
                        value={suggestTopic?.name || ""}
                        name="name"
                        id="name"
                        placeholder="Full Name"
                        className="form-control form-control-lg"
                        onChange={handleChange}
                        autoFocus
                    />
                    {inputValidationErrors && inputValidationErrors.name && (
                        <div className="invalid-data">{inputValidationErrors.name}</div>
                    )}
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <label htmlFor='email'>Enter Email Address*</label>
                    <input
                        disabled={isLoading || (currentMember && currentMember?.userId)}
                        type="email"
                        name="email"
                        id="email"
                        value={suggestTopic?.email || ""}
                        placeholder="Email"
                        className="form-control form-control-lg"
                        onChange={handleChange}
                        title="Please enter a valid email"
                    />
                    {inputValidationErrors && inputValidationErrors.email && (
                        <div className="invalid-data">{inputValidationErrors.email}</div>
                    )}
                </div>
            </div>

            <div className="col-lg-12">
                <div className="form-group">
                    <label htmlFor='message'>Topic Description*</label>
                    <textarea
                        disabled={isLoading}
                        name="message"
                        id="message"
                        value={suggestTopic?.message || ""}
                        placeholder="Describe your topic here"
                        className="form-control"
                        onChange={handleChange}
                    />
                    {inputValidationErrors && inputValidationErrors.message && (
                        <div className="invalid-data">{inputValidationErrors.message}</div>
                    )}
                </div>
            </div>

            {/* <div className="col-lg-12">
                <div className="form-group">
                    {formSubmitted && Object.values(suggestTopic).some(val => !val.trim()) && (
                        <div className="invalid-data">{ALL_FIELDS_ERROR_MESSAGE}</div>
                    )}
                </div>
            </div> */}

            <div className="col-lg-12">
                <div className="form-group">
                    <button
                        disabled={isLoading}
                        className={`rn-btn edu-btn w-100 ${isLoading ? 'btn-loading' : ''}`}
                        type="button"
                        onClick={handleSubmitSuggestion}
                    >
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                Submitting...
                            </>
                        ) : (
                            <>
                                <span>Submit Topic</span>
                                <i className="icon-arrow-right-line-right" />
                            </>
                        )}
                    </button>
                </div>
            </div>

            {result && (
                <div className="form-group">
                    <Result />
                </div>
            )}
        </div>
    );
}

export default SuggestTopic;
